export default __webpack_public_path__ + "static/media/injective.8aa556eb.svg";